<template>
  <table class="table table-sm table-list mb-1">
    <thead>
      <tr class="bg-light text-nowrap">
        <th>項目</th>
        <th v-for="stage in personalGoalStages">{{ stage.name }}</th>
        <th v-if="!isReadOnly"></th>
      </tr>
    </thead>
    <tbody v-if="scoresBySelf.length < 1">
      <tr v-for="(goal, i) in goals">
        <td>
          <input type="text" class="form-control form-control-sm" :name="'personal_goals[' + i + '][name]'" v-model="goal.name" v-if="!isReadOnly" required />
          <input type="hidden" class="form-control form-control-sm" :name="'personal_goals[' + i + '][id]'" v-model="goal.id" v-if="!isReadOnly" required />
          <span v-if="isReadOnly">{{ goal.name }}</span>
        </td>
        <td class="fit text-center" style="min-width: 100px;" v-for="(stage, j) in personalGoalStages">
          <input type="number" class="form-control form-control-sm" :name="'personal_goal_scores[' + i + '][' + stage.id + ']'" v-model="scores[i][stage.id]" />
        </td>
        <td class="fit" v-if="!isReadOnly">
          <button type="button" class="btn btn-danger btn-sm" @click="removeGoal(i)">{{ $t('削除') }}</button>
        </td>
      </tr>
    </tbody>

    <tbody v-else>
      <tr v-for="(goal, i) in goals">
        <td>
          <span>{{ goal.name }}</span>
          <input type="hidden" class="form-control form-control-sm" :name="'personal_goals[' + i + '][name]'" v-model="goal.name" required />
          <input type="hidden" class="form-control form-control-sm" :name="'personal_goals[' + i + '][id]'" v-model="goal.id" required />
        </td>
        <td class="fit text-center" style="min-width: 100px;" v-for="stage in personalGoalStages">
          <span v-if="isReadOnly">自己評価：{{ goalScoresBySelf[goal.id]?.[stage.id] }}</span>
          <input type="number" class="form-control form-control-sm" :name="'personal_goal_scores[' + i + '][' + stage.id + ']'" v-model="scores[i][stage.id]" />
        </td>
      </tr>
    </tbody>

  </table>
  <button type="button" class="btn btn-primary btn-sm" @click="addGoal" v-if="!isReadOnly">{{ $t('追加') }}</button>
</template>

<script>
  export default {
    props: {
      personalGoals: {
        type: Array,
        required: true,
      },
      personalGoalScores: {
        type: Array,
        required: true,
      },
      personalGoalScoresBySelf: {
        type: Array,
        default: [],
      },
      personalGoalStages: {
        type: Array,
        required: true,
      },
      isReadOnly: {
        type: Boolean,
        required: true
      }
    },

    data() {
      return {
        goals: [],
        scores: {},
        scoresBySelf: [],
        goalScoresBySelf: {},
      }
    },

    computed: {

    },

    created() {
      this.goals = this.personalGoals;
      this.scoresBySelf = this.personalGoalScoresBySelf;

      // 自分
      this.personalGoals.forEach((goal, i) => {
        if (!this.scores[i]) {
          this.scores[i] = {};
        }

        if (this.personalGoalScores.length > 0) {
          for (const score of this.personalGoalScores) {
            if (!this.scores[i][score.personal_goal_stage_id]) {
              this.scores[i][score.personal_goal_stage_id] = this.personalGoalScores?.find(s => s.personal_goal_id === goal.id && s.personal_goal_stage_id === score.personal_goal_stage_id)?.value ?? '';
            }
          }
        }
        else {
          for (const stage of this.personalGoalStages) {
            this.scores[i][stage.id] = '';
          }
        }
      });

      // 他人
      for (const score of this.scoresBySelf) {
        if (!this.goalScoresBySelf[score.personal_goal_id]) {
          this.goalScoresBySelf[score.personal_goal_id] = {};
        }

        if (!this.scores[score.personal_goal_id]) {
          this.scores[score.personal_goal_id] = {};
        }

        if (!this.goalScoresBySelf[score.personal_goal_id][score.personal_goal_stage_id]) {
          this.goalScoresBySelf[score.personal_goal_id][score.personal_goal_stage_id] = score.value;
        }

        if (!this.scores[score.personal_goal_id][score.personal_goal_stage_id]) {
          this.scores[score.personal_goal_id][score.personal_goal_stage_id] = this.personalGoalScores?.find(s => s.personal_goal_id === score.personal_goal_id && s.personal_goal_stage_id === score.personal_goal_stage_id)?.value ?? '';
        }
      }
    },

    methods: {
      addGoal() {
        const goal = {
          name: '',
        };
        this.goals.push(goal);
        this.scores[this.goals.length - 1] = {};
        for (const stage of this.personalGoalStages) {
          this.scores[this.goals.length - 1][stage.id] = '';
        }
      },
      removeGoal(i) {
        this.goals.splice(i, 1);
        delete this.scores[i];
        Object.entries(this.scores).forEach((score, i) => {
          delete this.scores[score[0]];
          this.scores[i] = score[1];
        });
      }
    }
  }
</script>
